export enum TipoOperacaoEnum {
    EXC = 'EXC',
    ALT = 'ALT',
    INC = 'INC',
}

export const TipoOperacaoEnumMap = new Map<string, any>([
    [TipoOperacaoEnum.EXC, { id: 1, descricao: 'Alteração', enum: TipoOperacaoEnum.EXC }],
    [TipoOperacaoEnum.ALT, { id: 2, descricao: 'Exclusão', enum: TipoOperacaoEnum.ALT }],
    [TipoOperacaoEnum.INC, { id: 3, descricao: 'Inclusão', enum: TipoOperacaoEnum.INC }],
]);
